// Dépense IA du mois (lecture des pièces, tri des mails, assistant, textes préparés) : seuils
// d'alerte sur le plafond mensuel partagé. Montants en micro-dollars.
//
// Espaces privés (D5) : la dépense d'un espace privé ne compte plus dans ce plafond commun ;
// elle est arrêtée par son propre plafond (`entites.plafond_ia_micro_usd`), réglé par un
// administrateur depuis la vue I3, ou ce défaut tant qu'il est nul.

import { formaterMontant } from './montant'

/** Plafond IA par défaut d'un espace privé sans plafond réglé (D5) : 10 $ par mois. */
export const PLAFOND_IA_PRIVE_DEFAUT_USD = 10
export const PLAFOND_IA_PRIVE_DEFAUT_MICRO_USD = PLAFOND_IA_PRIVE_DEFAUT_USD * 1_000_000

/** Plafond IA effectif d'un espace privé (D5) : le sien s'il est réglé, sinon le défaut. */
export function plafondIaEspace(plafondMicroUsd: number | null): number {
  return plafondMicroUsd ?? PLAFOND_IA_PRIVE_DEFAUT_MICRO_USD
}

/**
 * Reste d'alerte d'un espace privé : le reste d'alerte commun (5 $ par défaut) n'a pas de sens
 * face à un petit plafond d'espace (10 $ par défaut) ; borné au quart du plafond, pour que
 * « moitié » et « reste » ne tombent jamais ensemble, et qu'un plafond très bas n'alerte pas
 * dès 0 $ dépensé.
 */
export function resteAlerteEspace(resteAlerteCommunMicroUsd: number, plafondMicroUsd: number) {
  return Math.min(resteAlerteCommunMicroUsd, Math.floor(plafondMicroUsd / 4))
}

export type SeuilDepenseIa = 'moitie' | 'reste'

/**
 * Seuils franchis : la moitié du plafond, puis un reste sous le montant d'alerte. Un plafond
 * nul n'en franchit aucun ; un reste d'alerte nul désactive le second.
 */
export function seuilsDepenseIa(e: {
  depense: number
  plafond: number
  resteAlerte: number
}): SeuilDepenseIa[] {
  if (e.plafond <= 0) return []
  const seuils: SeuilDepenseIa[] = []
  if (e.depense * 2 >= e.plafond) seuils.push('moitie')
  if (e.resteAlerte > 0 && e.plafond - e.depense < e.resteAlerte) seuils.push('reste')
  return seuils
}

/** « 17,50 USD » : micro-dollars arrondis au centime. */
export function formaterDollars(microUsd: number): string {
  return formaterMontant(Math.round(microUsd / 10_000), 'USD')
}

/**
 * Entité où compter la dépense de l'assistant des fiches ouvert sans fiche (rien ne la situe) :
 * l'espace privé de l'acteur s'il n'est pas administrateur et n'en a qu'un (elle pèse alors
 * sur le plafond de cet espace, pas sur le plafond commun) ; sinon null, la cloison commune.
 */
export function entiteDeDepenseSansFiche(acteur: {
  administrateur: boolean
  espacesPrives: readonly string[]
}): string | null {
  if (acteur.administrateur || acteur.espacesPrives.length !== 1) return null
  return acteur.espacesPrives[0]!
}
